import { defineStore } from 'pinia';
import { useMapStore } from '@/store/modules/map';
import { SelectedFarmBlock } from '@/store/models/common';
import { LocalStorage } from 'quasar';
import { Season } from '../models/configuration';
import { DEFAULT_CENTER } from '@/utils/ol-map';

export const useCommonStore = defineStore('common', {
  state: () => ({
    View: 'map',
    SelectedFarmBlock: {
      farmId: 0,
      name: '',
      blockName: '',
      center: [...DEFAULT_CENTER]
    } as SelectedFarmBlock,
    CurrentSeason: null as Season | null,
    MapTableView: false,
    CurrentCrop: null as number | null,
    StartDate: '',
    EndDate: '',
    // Farm the Crop / Season / From-To selection below was built for. The
    // filter toolbar is destroyed and re-created on every navigation
    // (App.vue keys its router-view on the URL), so it needs this to tell a
    // first visit - build the selection from the farm's season - from a
    // re-mount, where the selection the user made must survive.
    FilterFarmId: null as number | null,
    TimerStartDate: '',
    TimerEndDate: '',
    MapViewTab: 'Flowering',
    CalendarDayList: {
      1: { name: 'January', shortName: 'Jan', days: 31 },
      2: { name: 'February', shortName: 'Feb', days: 29 },
      3: { name: 'March', shortName: 'Mar', days: 31 },
      4: { name: 'April', shortName: 'Apr', days: 30 },
      5: { name: 'May', shortName: 'May', days: 31 },
      6: { name: 'June', shortName: 'Jun', days: 30 },
      7: { name: 'July', shortName: 'Jul', days: 31 },
      8: { name: 'August', shortName: 'Aug', days: 31 },
      9: { name: 'September', shortName: 'Sep', days: 30 },
      10: { name: 'October', shortName: 'Oct', days: 31 },
      11: { name: 'November', shortName: 'Nov', days: 30 },
      12: { name: 'December', shortName: 'Dec', days: 31 }
    } as {
      [key: number]: { name: string; shortName: string; days: number };
    }
  }),
  actions: {
    changeView(view: string) {
      const mapStore = useMapStore();
      mapStore.updateMapSize();
      setTimeout(() => {
        mapStore.stopUpdateAnimation();
      }, 600);
      this.View = view;
    },
    setSelectedFarmBlock(value: SelectedFarmBlock) {
      if (value.farmId && value.farmId != 0) {
        LocalStorage.set('SelectedFarmBlock', value);
      }
      this.SelectedFarmBlock = value;
    },
    setCurrentCrop(value: number | null) {
      this.CurrentCrop = value;
    },
    setCurrentSeason(value: Season | null) {
      this.CurrentSeason = value;
    },
    setMapTableView(value: boolean) {
      this.MapTableView = value;
    },
    setStartDate(value: string) {
      this.StartDate = value;
    },
    setEndDate(value: string) {
      this.EndDate = value;
    },
    setFilterFarmId(value: number | null) {
      this.FilterFarmId = value;
    },
    setTimerStartDate(value: string) {
      this.TimerStartDate = value;
    },
    setTimerEndDate(value: string) {
      this.TimerEndDate = value;
    },
    setMapViewTab(tab: string) {
      this.MapViewTab = tab;
    }
  }
});

